
import React from 'react';
import Layout from '@/components/Layout/Layout';
import DateCalculator from '@/components/Calculator/DateCalculator';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DateCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/calculators" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Date Calculator</h1>
          <p className="text-gray-600 mb-6">
            Calculate the difference between dates or add/subtract time from a specific date.
          </p>
        </div>
        
        <div className="mb-8">
          <DateCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Date Calculator</h2>
          <p>
            The date calculator helps you determine the exact time between two dates or 
            calculate a future or past date based on a specific time interval.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Features</h3>
          <ul className="list-disc ml-6">
            <li>Calculate days, weeks, months, and years between two dates</li>
            <li>Add or subtract a specific time period from a date</li>
            <li>Determine weekdays and working days between dates</li>
            <li>Account for holidays and special calendar events</li>
            <li>Convert between different date formats</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Use Cases</h3>
          <ul className="list-disc ml-6">
            <li>Project planning and deadline calculations</li>
            <li>Age calculations</li>
            <li>Invoice and payment due date calculations</li>
            <li>Contract duration analysis</li>
            <li>Travel planning</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default DateCalculatorPage;
